<template>
  <div class="Outdated" v-if="visible">
    <h2>Web Browser ของคุณไม่รองรับการใช้งานเว็บไซต์นี้</h2>
    <p>โปรดใช้ browser รุ่นใหม่ หรือถ้าใช้คุณกำลังใช้ in-app browser เช่นเปิดใน Line, Twitter หรือ Facebook กรุณาใช้ browser อื่นแทน เช่น Chrome หรือ Firefox เป็นต้น</p>
    <a href="#" class="browser-close" @click.prevent="close()"><img :src="$utils.svg(require('../assets/img/ic-close.svg'))" alt="close" width="25" height="15" /></a>
  </div>
</template>

<script>
// import InApp from 'detect-inapp'
// const blacklists = ['line', 'twitter', 'facebook', 'messenger']

export default {
  name: 'Outdated',
  data () {
    return {
      visible: false
    }
  },
  methods: {
    close () {
      this.visible = false
    },
    checkBrowser (checkInApp) {
      this.visible = false
      return // bypass all conditions
      // const who = navigator.sayswho().replace(/MSIE/, 'IE')
      // if (who !== 'IE 11' && who.match(/^IE [0-9]{1,2}/)) {
      //   this.visible = true
      //   return
      // }

      // if (checkInApp) {
      //   const inapp = new InApp(navigator.userAgent || navigator.vendor || window.opera)
      //   if (blacklists.indexOf(inapp.browser) !== -1) {
      //     this.visible = true
      //   } else {
      //     this.visible = false
      //   }
      // }
    }
  }
}
</script>

<style>
.Outdated {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  padding: 30px 10px 0;
  background: #F0584E;
  color: #fff;
  text-align: center;
  font-size: 0.85em;
}
.Outdated .btn,
.Outdated h2 { color: #fff;}
.Outdated .btn:hover {
  color: #F0584E
}
.browser-close {
  position: absolute;
  top: 5px;
  right: 10px;
  cursor: pointer;
}


</style>



// WEBPACK FOOTER //
// Outdated.vue?351c98ac